import React, { useEffect } from "react";
import styles from "./CooperationPage.module.scss";
import SideBar from "../../components/sideBar/SideBar";
import useWindowSize from "../../hooks/useWindowSize";
import Cooperation1 from "../../components/icons/cooperations/Cooperation-1";
import Cooperation2 from "../../components/icons/cooperations/Cooperation-2";
import Cooperation3 from "../../components/icons/cooperations/Cooperation-3";
import Cooperation4 from "../../components/icons/cooperations/Cooperation-4";
import { Link } from "react-router-dom";
import TV from "../../static/imgs/tv.png";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";
import GradientBackdrop from "../../components/shared/GradientBackdrop/GradientBackdrop";
import LinkGuide from "../../components/shared/LinkGuide/LinkGuide";

const CooperationPage = () => {
  const { windowSize } = useWindowSize();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className={styles.wrapper}>
      <Header className={styles.headerWrapper} />

      <GradientBackdrop/>

      {windowSize !== "mobile" && <SideBar />}
      <div className={styles.container}>
        <div className={styles.titleWrapper}>
          <h3 className={styles.title}>{t("Cooperation")}</h3>
          <p className={styles.subheadingText}>
            {t("serviceIssues")}{" "}
            {
              <Link className={styles.colorfulText} to={ROUTES.SUPPORT}>
                {t("reportIssues")}
              </Link>
            }
            .
          </p>
        </div>
        <div className={styles.content}>
          <section className={styles.advertisementWrapper}>
            <div className={styles.iconWrapper}>
              <Cooperation1 className={styles.advertisementIcon} />
              <Cooperation2 className={styles.advertisementIcon} />
              <Cooperation3 className={styles.advertisementIcon} />
              <Cooperation4 className={styles.advertisementIcon} />
            </div>
            <div className={styles.advertisementTitleWrapper}>
              <h3 className={styles.title}>{t("advertising")}</h3>
              <p className={styles.subtitle}>
                {t("adPlacement")}
                <span className={styles.boldDecor}>HIVIEWER</span> {t("contactAtBottom")}
              </p>
              {/*<Link to="mailto:ads@hiviewer.ai" className={styles.link}>ads@hiviewer.ai</Link>*/}
            </div>
          </section>
          <section className={styles.partnershipWrapper}>
            <div className={styles.advertisementTitleWrapper}>
              <h3 className={styles.title}>{t("partnership")}</h3>
              <p className={styles.subtitle}>{t("openToProposals")}</p>
              {/*<Link to="mailto:partners@hiviewer.ai" className={styles.link}>partners@hiviewer.ai</Link>*/}
            </div>
            <img width={460} height={424} src={TV} alt="#" />
          </section>
          <section className={styles.questionsWrapper}>
            <p className={styles.questionText}>{t("proposalsContact")}</p>
            <Link to="mailto:info@hiviewer.ai" className={styles.questionLink}>
              info@hiviewer.com
            </Link>
          </section>
        </div>
      </div>
      <Footer source={""} />
      <LinkGuide/>
    </section>
  );
};

export default CooperationPage;
